export default __webpack_public_path__ + "static/media/druidlogo.9ac928f0.png";